<template>
  <div id='load-content'>
    <div class="ui massive visible slow text purple loader">Loading Content</div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style lang="less" scoped>
#load-content {
  width: 100vw;
  height: 100vh;
  background-color: #221d24;
  color: #FFF;
  font-size: 10px;
  background-image: url('../../assets/bl-video-placeholder.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  .loader {
    display: flex;
    align-items: flex-end;
    height: 100%;
    padding-bottom: calc(5.35714286rem + 45px);
    &:before, &:after {
      top: auto;
      bottom: 45px;
    }
  }
}
</style>
